import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {
    return (
        <div className={`ns-autocomplete-submit ${className}`}>
            <button type="submit" className="btn btn--outline btn--primary">
                <span>{text}</span>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 24 24"><path d="M6 12h12.5m0 0-6-6m6 6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
        </div>
    )
}